import rules from './rules.json';
import common from './common.json';

export default {
  rules,
  common,
};
